import React from 'react';
import { Line } from 'react-chartjs-2';


const LineChart = (props) => {
    const data = {
        labels: props.labels,
        datasets: props.datasets
    };

    return (
        <div className={`${props.className}`}>
            <Line
                data={data}
                width={props.width}
                height={props.height}
                legend={{ position: "bottom" }}
                options={{
                    scales: {
                        yAxes: [{
                            display: true,
                            ticks: {
                                suggestedMin: 0,
                                callback: function (value, index, values) {
                                    return props.xAxesOptions && props.xAxesOptions.render ? props.xAxesOptions.render(value) : value;
                                }
                            },
                            gridLines: {
                                borderDash: [8, 4]
                            }
                        }],
                        xAxes: [{
                            display: true,
                            gridLines: {
                                borderDash: [8, 4]
                            }
                        }]
                    }
                }}
            />
        </div>
    );
};

LineChart.defaultProps = {
    xAxesOptions: {}
}

export { LineChart };